import { motion } from "framer-motion";

const easing = [0.22, 1, 0.36, 1];

// Simple scroll-triggered fade/slide reveal
export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, ease: easing, delay }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

// Masked, line-by-line staggered text reveal for headings
export const TextReveal = ({ lines = [], className = "", lineClassName = "", start = 0 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="reveal-mask">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 0.9, ease: easing, delay: start + i * 0.12 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export default Reveal;
